import { render, staticRenderFns } from "./compare1.vue?vue&type=template&id=66aa938f&scoped=true"
import script from "./compare1.vue?vue&type=script&lang=js"
export * from "./compare1.vue?vue&type=script&lang=js"
import style0 from "./compare1.vue?vue&type=style&index=0&id=66aa938f&prod&lang=css"
import style1 from "./compare1.vue?vue&type=style&index=1&id=66aa938f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa938f",
  null
  
)

export default component.exports